import {concatUrl} from "./createUrls";

export const getAemContentUrl = (
  aemBaseUrl: string,
  page: string,
  country: string,
  locale: string,
  persona?: string,
  entitlements: string[] = [],
): string => {
  if (page.endsWith(".json")) {
    return concatUrl(
      aemBaseUrl,
      `${country}/${locale}/tools/${page}`,
    );
  } else if (!!persona && entitlements?.length !== 0) {
    return concatUrl(
      aemBaseUrl,
      `${country}/${locale}/tools/${page}/endpoint.pro-model.${entitlements.join(
        ".",
      )}.${persona}.json`,
    );
  } else if (!!persona && entitlements?.length === 0) {
    return concatUrl(
      aemBaseUrl,
      `${country}/${locale}/tools/${page}/endpoint.pro-model.${persona}.json`,
    );
  } else {
    return concatUrl(
      aemBaseUrl,
      `${country}/${locale}/tools/${page}/endpoint.pro-model.json`,
    );
  }
};
